import { IGlobalConfigurationState } from '@app/store/modules/global'
import { humanize } from '@app/utils/formatting'
import * as React from 'react'
import { Input } from 'reactstrap'

interface IDevelopmentSiteStatusSelectorProps {
  bsSize?: 'lg' | 'sm'
  className?: string
  includeAll?: boolean
  name?: string
  onChange: (newType: string) => void
  required?: boolean
  style?: React.CSSProperties
  value: string
}

type DevelopmentSiteStatusSelectorProps = IDevelopmentSiteStatusSelectorProps &
  IGlobalConfigurationState

export default class DevelopmentSiteStatusSelector extends React.PureComponent<
  DevelopmentSiteStatusSelectorProps
> {
  public render() {
    return (
      <Input
        bsSize={this.props.bsSize}
        className={this.props.className}
        name={this.props.name}
        onChange={(e) => this.props.onChange(e.target.value)}
        required={this.props.required}
        style={this.props.style}
        type='select'
        value={this.props.value}
      >
        {this.props.includeAll === true && <option value=''>All</option>}
        {this.props.configuration.developmentSiteStatuses.map((opt) => (
          <option key={opt} value={opt}>
            {humanize(opt)}
          </option>
        ))}
      </Input>
    )
  }
}
